import { HHTypography } from '@hinge-health/react-component-library';
import {
  DiscountType,
  IDiscount,
  IDiscountUsage,
} from '../../../utils/discount-utils';

export interface FreeBillableActivitiesUsageProps {
  discountData: IDiscount;
}

const getUsageDisplay = (discountUsage: IDiscountUsage): string => {
  if (discountUsage.loading || discountUsage.error) {
    return '--';
  }

  return discountUsage.totalCount?.toLocaleString() ?? '0';
};

const FreeBillableActivitiesUsage = ({
  discountData,
}: FreeBillableActivitiesUsageProps): JSX.Element => {
  const totalFreeCareSessions = discountData.discountDetails[0]?.discount;
  return (
    <HHTypography hhVariant="inherit">
      {getUsageDisplay(discountData.discountDetails[0].discountUsage)}/
      {totalFreeCareSessions ? totalFreeCareSessions.toLocaleString() : null}{' '}
      {discountData.discountType === DiscountType.freeBillableActivities
        ? 'Free Billable Activities Used'
        : 'Program Cap Credits Used'}
    </HHTypography>
  );
};

export default FreeBillableActivitiesUsage;
